import React, { FC, useContext, useEffect } from "react";
import { appInsights, reactPlugin, withAITracking } from "../../appInsights";
import sessionService from "../../services/session.service";

import LayoutOfDashboard from "@layout/defaultForDashboard";
import ProgressBar from "./progressBar";

import { UploadContext } from "../../context/uploadProvider";

import { Spin, Upload, Button, Input } from "antd";
import { InboxOutlined, DeleteOutlined } from "@ant-design/icons";

import "./uploadFiles.scss";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";

const UploadFile: FC<any> = () => {
  useEffect(() => {
    console.log("UploadFile.useEffect");
    appInsights.setAuthenticatedUserContext(sessionService?.getUser()?.email);
    appInsights.trackPageView({name:"Upload File"});
  },[]);
  const { Dragger } = Upload;
  const {
    onChangeNote,
    message,
    props,
    fileList,
    isUpload,
    onRemoveFile,
    onUpload,
    uploadProgress,
    spinLoader,
    uploadSuccess,
    strValidation,freeText
  } = useContext(UploadContext);

  return (
    <LayoutOfDashboard>
      <div className="UploadScreen">
        <div className="up">
          <div className="DomainName">
            <span className="DomainHeading">Domain </span>
            <span className="DomainTitle" style={{color:"#0072e3"}}>
              : {sessionService.getClient()?.clientName}
            </span>
          </div>

          <div className="uploadScreenBody">
            <div className="uploadScreenInputField">
              {/* <label className="label">File Label</label><br/> */}
              <Input
                disabled={isUpload}
                className="inputText"
                bordered={false}
                placeholder="Please type in folder name i.e. Month, Year, Data Type etc"
                onChange={onChangeNote}
                allowClear={true}
                maxLength={15}
              />
            </div>
            {strValidation ? (
              <span style={{ color: "red" }}>{message}</span>
            ) : null}
            <div className="dragAndDrop">
              <Dragger {...props}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
                <p className="ant-upload-hint">
                  Support for a single or bulk upload
                </p>
              </Dragger>
            </div>
            {fileList.length > 0 ? (
              <>
                <span style={{ color: "black" }}>Selected Files</span>
                <br />
                {fileList.map((singleFile: any) => (
                  <div className="fileCard" key={singleFile.uid}>
                    <span className="fileCardName">{singleFile.name}</span>
                    {!isUpload ? (
                      <DeleteOutlined
                        className="fileCardRemove"
                        onClick={() => onRemoveFile(singleFile.uid)}
                      />
                    ) : null}
                  </div>
                ))}
              </>
            ) : null}
            {!isUpload ? (
              <div className="buttonDiv">
                <Button
                  size="large"
                  disabled={!(fileList.length > 0 && !strValidation && freeText.length>=3 && freeText.length<=15)}
                  className={`${(!(fileList.length > 0 && !strValidation && freeText.length>=3 && freeText.length<=15))?"disabledButton":"uploadButton"}`}
                  onClick={onUpload}
                >
                  Upload
                </Button>
              </div>
            ) : null}
            {isUpload ? (
              <>
                <ProgressBar percent={uploadProgress} strokeColor={"#EF6D2A"} />
              </>
            ) : null}
            {spinLoader ? (
              <div className="spinMessage">
                <Spin indicator={<HealthemSpinner/>}/>
                {message}
              </div>
            ) : uploadSuccess ? (
              <div className="successMessage">{message}</div>
            ) : null}
          </div>
        </div>
      </div>
    </LayoutOfDashboard>
  );
};

export default withAITracking(reactPlugin, UploadFile);
